import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

function Section({ heading, children }) {
  return (
    <section className="rounded-2xl border border-nm-border bg-nm-surface p-5 sm:p-6">
      <h2 className="text-lg font-bold text-nm-text">{heading}</h2>
      <div className="mt-3 space-y-2.5 text-sm leading-relaxed text-nm-muted">
        {children}
      </div>
    </section>
  );
}

function List({ items }) {
  return (
    <ul className="list-disc space-y-2 pl-5">
      {items.map((t, i) => (
        <li key={i}>{t}</li>
      ))}
    </ul>
  );
}

export default function KetentuanPage() {
  const waUrl = buildStockWhatsAppUrl();
  return (
    <>
      <Seo
        title="Ketentuan Layanan"
        description="Ketentuan layanan Nofina Movie: pemesanan, harga dan pembayaran, aktivasi dan penggunaan, pembatalan/refund/garansi, layanan pihak ketiga, dan perubahan ketentuan."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="max-w-2xl">
          <h1 className="text-3xl font-extrabold text-nm-text sm:text-4xl">
            Ketentuan Layanan Nofina Movie
          </h1>
          <p className="mt-3 text-nm-muted">
            Dengan melakukan pemesanan melalui Nofina Movie, pelanggan dianggap
            telah membaca, memahami, dan menyetujui ketentuan layanan berikut.
          </p>
        </header>

        <div className="mt-8 space-y-5">
          <Section heading="Pemesanan">
            <List
              items={[
                "Pelanggan memilih produk dan durasi melalui katalog Nofina Movie.",
                "Detail pilihan dikirimkan melalui WhatsApp untuk konfirmasi dan penyelesaian pesanan.",
                "Pelanggan bertanggung jawab memastikan nama produk, durasi, harga, dan kode produk sudah sesuai sebelum melanjutkan pembayaran atau aktivasi.",
                "Ketersediaan produk dapat berubah. Pesanan diproses berdasarkan ketersediaan pada saat konfirmasi.",
              ]}
            />
          </Section>

          <Section heading="Harga dan pembayaran">
            <List
              items={[
                "Harga yang ditampilkan adalah harga untuk variant dan durasi yang sedang dipilih.",
                "Detail pembayaran diberikan melalui percakapan WhatsApp Nofina Movie.",
                "Pelanggan wajib memastikan tujuan dan nominal pembayaran sudah sesuai dengan instruksi yang diterima.",
                "Jangan melakukan pembayaran kepada nomor atau rekening yang tidak diberikan melalui kanal Nofina Movie.",
              ]}
            />
          </Section>

          <Section heading="Aktivasi dan penggunaan">
            <List
              items={[
                "Produk digital dikirimkan atau diaktifkan sesuai petunjuk yang diberikan setelah pesanan dikonfirmasi.",
                "Pelanggan wajib mengikuti seluruh petunjuk aktivasi dan penggunaan.",
                "Akun private tidak boleh dibagikan, dipindahtangankan, atau digunakan pada lebih dari satu perangkat, kecuali dinyatakan berbeda pada informasi produk.",
                "Pelanggan tidak diperbolehkan mengubah password, data akun, profil, metode pembayaran, atau pengaturan penting tanpa instruksi.",
                "Pelanggan bertanggung jawab memastikan perangkat dan aplikasi yang digunakan kompatibel dengan produk yang dipilih.",
              ]}
            />
          </Section>

          <Section heading="Pembatalan, refund, dan garansi">
            <List
              items={[
                "Pesanan yang sudah berhasil diaktifkan tidak dapat dibatalkan atau direfund.",
                "Garansi berlaku tujuh hari sejak aktivasi berhasil dan hanya mencakup kendala teknis yang berasal dari layanan atau akun yang diberikan.",
              ]}
            />
            <p>
              Ketentuan selengkapnya tersedia pada halaman{" "}
              <Link to="/garansi" className="font-semibold text-nm-red hover:underline">
                Ketentuan Garansi
              </Link>
              .
            </p>
          </Section>

          <Section heading="Layanan pihak ketiga">
            <p>
              Produk dalam katalog digunakan melalui platform atau aplikasi
              pihak ketiga. Nama, logo, dan merek terkait merupakan milik
              masing-masing pemiliknya. Perubahan fitur, kebijakan,
              kompatibilitas, suspend, atau gangguan pada platform pihak ketiga
              dapat berada di luar kendali Nofina Movie.
            </p>
          </Section>

          <Section heading="Perubahan ketentuan">
            <p>
              Nofina Movie dapat memperbarui ketentuan layanan apabila terdapat
              perubahan pada produk atau proses layanan. Versi yang berlaku
              adalah ketentuan yang ditampilkan pada website saat pelanggan
              melakukan pemesanan.
            </p>
          </Section>
        </div>

        <div className="mt-8 rounded-2xl border border-nm-border bg-nm-surface p-6 text-center">
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ketentuan-whatsapp"
            className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-wa px-6 font-semibold text-white shadow-lg shadow-wa/20 hover:bg-wa-hover sm:w-auto"
          >
            <MessageCircle className="h-5 w-5" />
            Cek Stok via WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
